import React from "react"


const Footer = () => {
  return (
	<footer className="report-footer">
	  <p>
		Source:{" "}
		<a href="https://marketproof.com" className="link-text">
		  Marketproof
		</a>{" "}
		| For informational purposes only, data from entities deemed reliable,
		but may contain errors, omissions, or changes without notice.
	  </p>
	</footer>
  );
};

export default Footer;